import { createFileRoute } from '@tanstack/react-router'

import { AccountLayout } from '@/containers/accountLayout'

export const Route = createFileRoute('/_authenticated/account')({
  component: AccountLayout,
})
